module.exports = __webpack_public_path__ + "static/media/Couples.b2c47295.svg";